import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Button } from '../../../components';
import pricingSectionStyles from './PricingSection.module.scss';

const PricingSection = () => (
  <section id="pricing-section" className={pricingSectionStyles.pricing} aria-labelledby="pricing-title">
    <div className={pricingSectionStyles.pricingTitle}>
      <h2 id="pricing-title">Pricing</h2>
      <p>We have perfect pricing options for all size of businesses</p>
    </div>
    <div className={pricingSectionStyles.pricingOptions}>
      <div className={pricingSectionStyles.pricingOption}>
        <div className={pricingSectionStyles.pricingOptionName}><p>BASIC</p></div>
        <div className={pricingSectionStyles.pricingOptionDetail}><p>Ideal for individuals or small businesses having single app</p></div>
        <div className={pricingSectionStyles.pricingOptionFeatures}>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>Basic AI response</p></div>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>1 Application</p></div>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>Up to 100 reviews per month</p></div>
        </div>
      </div>
      <div className={pricingSectionStyles.pricingOption}>
        <div className={pricingSectionStyles.pricingOptionName}><p>STANDARD</p></div>
        <div className={pricingSectionStyles.pricingOptionDetail}><p>Suitable for businesses looking for managing multiple apps</p></div>
        <div className={pricingSectionStyles.pricingOptionFeatures}>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>Advanced AI response</p></div>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>3 Applications</p></div>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>Increased number of reviews per month</p></div>
        </div>
      </div>
      <div className={pricingSectionStyles.pricingOption}>
        <div className={pricingSectionStyles.pricingOptionName}><p>PREMIUM</p></div>
        <div className={pricingSectionStyles.pricingOptionDetail}><p>Suitable for businesses looking for comprehensive review management with advanced AI capabilities</p></div>
        <div className={pricingSectionStyles.pricingOptionFeatures}>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>Advanced AI response</p></div>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>Unlimited number of Applications</p></div>
          <div><FontAwesomeIcon icon={faCheck} aria-hidden="true" /><p>Unlimited number of reviews per month</p></div>
        </div>
      </div>
    </div>
  </section>
);

export default PricingSection; 
